import { createAction } from '@reduxjs/toolkit';

export const requestCreateMessage = createAction('chat/createMesssage');
export const requestViewAllChats = createAction('chat/viewAllChats');
export const requestViewChat = createAction('chat/viewChat');
export const startPollingChat = createAction('chat/startPollingChat');
export const stopPollingChat = createAction('chat/stopPollingChat');
export const requestViewSupportChat = createAction('chat/viewSupportChat');
export const requestCreateSupportMessage = createAction('chat/createSupportMessage');
export const requestViewAllSupportChats = createAction('chat/viewAllSupportChats');
